
import "./AttributesTable.css";
const AttributesTable = ({ attributes }) => {
  if (!attributes || attributes.length === 0) {
    return <p className="text-muted">No technical specifications available.</p>;
  }

  return (
    <table className="table table-striped mt-3">
      <tbody>
        {attributes.map((attr, index) => (
          <tr key={index}>
            <th style={{ width: "40%", backgroundColor: "#ffffffff" }}>
              {attr.name}
            </th>
            <td>{attr.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default AttributesTable;
